import { Table } from '@mantine/core';
import React from 'react';
import { ReactComponent as NoBlogIcon } from 'assets/icons/noBlogicon.svg';

import PrimaryButton from 'components/primaryButton';
import { useState } from 'react';

//hooks get blog data

import Usegetblogs from '../hooks/usegetblogdata';
import AddNewStroryModal from './addnewstrorymodal';
import StoriesReviewTable from './storiesreviewstable';

const StoriesForReview = ({ searchText, filterValue }) => {
  const blogData = Usegetblogs({
    isDeleted: 'False',
    isDraft: 'False',
    isPublished: 'False',
    searchText: searchText,
    filterValue: filterValue,
  });
  const [newStoryModal, setNewStoryModal] = useState(false);

  return (
    <React.Fragment>
      {blogData?.data?.data.length === 0 ? (
        <div className='bg-[#fff] min-h-[72vh] rounded-xl shadow-2xl p-4 flex justify-center items-center flex-col'>
          <NoBlogIcon />
          <p className='text-[#535353] mt-4 text-base'>
            Seems like you have not written any stories yet{' '}
          </p>
          <button className='mt-4' onClick={() => setNewStoryModal(true)}>
            <PrimaryButton>Add a story</PrimaryButton>
          </button>
        </div>
      ) : (
        <div className='bg-[#fff] min-h-[70vh] rounded-xl shadow-2xl mt-5'>
          <Table verticalSpacing='lg' highlightOnHover>
            <thead>
              <th className='bg-[#FFE8E1] rounded-tl-xl py-4 w-[250px]'>
                Submitted by
              </th>
              <th className='bg-[#FFE8E1]'>Topic</th>
              <th className='bg-[#FFE8E1]' style={{ textAlign: 'left' }}>
                Story preview
              </th>
              <th className='bg-[#FFE8E1]'>Action</th>
              <th className='bg-[#FFE8E1] rounded-tr-xl '>Publish</th>
            </thead>
            <tbody className=' w-full max-h-20 border-none'>
              {blogData?.data?.data.length === 0 ? null : (
                <>
                  {blogData?.data?.data?.map((eachBlog) => (
                    <StoriesReviewTable key={eachBlog.id} data={eachBlog} />
                  ))}{' '}
                </>
              )}
            </tbody>
          </Table>
        </div>
      )}
      <AddNewStroryModal
        setNewStoryModal={setNewStoryModal}
        newStoryModal={newStoryModal}
      />
    </React.Fragment>
  );
};

export default StoriesForReview;
